/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Tournament_Deck_Locked_RoundInputs */



/**
* | output |
* | --- |
* | "Cannot modify a deck for a round that has already started" |
*
* @param {Err_Tournament_Deck_Locked_RoundInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const err_tournament_deck_locked_round = /** @type {((inputs?: Err_Tournament_Deck_Locked_RoundInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Tournament_Deck_Locked_RoundInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Impossible de modifier un deck pour une ronde déjà commencée")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se puede modificar un mazo para una ronda que ya ha comenzado")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Não é possível modificar um deck para uma rodada que já começou")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile modificare un deck per un round già iniziato")
	return /** @type {LocalizedString} */ ("Cannot modify a deck for a round that has already started")
});